export const LISTENING_OVERVIEW_MULTI_TOPIC = [
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 0,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 0,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 16,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_ENGAGEMENTS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 16,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_ENGAGEMENTS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 32,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_IMPRESSIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 32,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_IMPRESSIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 6,
    x: 0,
    y: 48,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
      secondary_aggregate_by: 'CHANNEL',
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 6,
    x: 0,
    y: 64,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
      secondary_aggregate_by: 'SENTIMENT',
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 6,
    x: 0,
    y: 80,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
      secondary_aggregate_by: 'AGE',
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 6,
    x: 0,
    y: 96,
    meta: {
      aggregate_by: 'TOPIC',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
      secondary_aggregate_by: 'GENDER',
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 6,
    x: 0,
    y: 112,
    meta: {
      aggregate_by: 'COUNTRY',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
      secondary_aggregate_by: 'TOPIC',
    },
  },
  {
    h: 20,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 128,
    meta: {
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['ENGAGEMENTS'],
      sort_order: 'DESC',
    },
  },
];
